export const GET_CONTACT = "GET_CONTACT";
export const UPDATE_CONTACT = "UPDATE_CONTACT";
export const DELETE_CONTACT = "DELETE_CONTACT";
export const LOAD_CONTACT = "LOAD_CONTACT";
export const RESET_CONTACTS = "RESET_CONTACTS";
export const GET_SEGMENTS = "GET_SEGMENTS";
export const SAVE_SEGMENTS = "SAVE_SEGMENTS";
